// @mui
import { Box } from '@mui/material';
//
import { CONTAINER, STAGE, TYPE } from '../../theme/stage';
import { ANCHOR, APPROACH } from './copy';
import Eyebrow from './primitives/Eyebrow';
import ReadAlong from './primitives/ReadAlong';
import Reveal from './primitives/Reveal';

// ----------------------------------------------------------------------

export default function Approach() {
  return (
    <Box
      component="section"
      id={ANCHOR.approach}
      aria-labelledby={APPROACH.titleId}
      sx={{
        pt: { xs: '88px', sm: '160px', lg: '200px' },
        scrollMarginTop: { xs: '-88px', sm: '-160px', lg: '-200px' },
        '&:focus': { outline: 'none' },
      }}
    >
      <Box sx={CONTAINER}>
        <Reveal>
          <Eyebrow align="center">{APPROACH.eyebrow}</Eyebrow>
        </Reveal>

        <ReadAlong
          id={APPROACH.titleId}
          parts={APPROACH.statement}
          sx={{
            ...TYPE.statement,
            m: '0 auto',
            maxWidth: { xs: 'none', sm: '18em', lg: '16em' },
            textAlign: 'center',
            textWrap: 'balance',
          }}
        />

        <Box
          component="ul"
          sx={{
            listStyle: 'none',
            p: 0,
            mt: { xs: '48px', sm: '64px', md: '80px' },
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
            rowGap: '40px',
            columnGap: '48px',
          }}
        >
          {APPROACH.principles.map(({ title, body }, index) => (
            <Reveal key={title} component="li" delay={index * 80}>
              <Box
                sx={{
                  borderTop: `1px solid ${STAGE.line}`,
                  pt: { xs: '28px', sm: '32px' },
                }}
              >
                <Box
                  component="h3"
                  sx={{
                    ...TYPE.principleTitle,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    m: 0,
                    color: STAGE.ink,
                  }}
                >
                  <Box
                    component="span"
                    aria-hidden
                    sx={{
                      flexShrink: 0,
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      bgcolor: STAGE.bisque,
                    }}
                  />
                  {title}
                </Box>
                <Box
                  component="p"
                  sx={{ ...TYPE.body, m: '12px 0 0', color: STAGE.ink2, textWrap: 'pretty' }}
                >
                  {body}
                </Box>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
